<template>
  <div class="antiMoneyLaunderingDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="title" v-if="AMLId">{{ $t.antiMoneyLaundering.title2 }}</div>
      <div class="title" v-else>{{ $t.antiMoneyLaundering.title1 }}</div>

      <div class="multi-table">
        <div v-for="(item, index) in form.SCAN_MODEL_LIST" :key="index">
          <van-field
            v-model="item.NAME"
            :label="$t.antiMoneyLaundering.name"
            :placeholder="AMLId ? '' : $t.meta.input"
            :disabled="AMLId ? true : false"
            required
            :rules="formRule"
            @blur="keywordSearch"
          />

          <van-field
            v-model="item.ADDRESS"
            :label="$t.antiMoneyLaundering.address"
            :placeholder="AMLId ? '' : $t.meta.input"
            :disabled="AMLId ? true : false"
          />

          <van-field
            v-model="item.IDENTITYNUM"
            :label="$t.antiMoneyLaundering.identityNum"
            :placeholder="AMLId ? '' : $t.meta.input"
            :disabled="AMLId ? true : false"
            @blur="keywordSearch"
          />

          <van-field
            v-model="item.BIC"
            :label="$t.antiMoneyLaundering.bic"
            :placeholder="AMLId ? '' : $t.meta.input"
            :disabled="AMLId ? true : false"
          />

          <van-field
            v-model="item.COUNTRY"
            :label="$t.antiMoneyLaundering.country"
            :placeholder="AMLId ? '' : $t.meta.input"
            :disabled="AMLId ? true : false"
          />

          <van-field
            v-model="item.NARRATIVE"
            :label="$t.antiMoneyLaundering.narrative"
            :placeholder="AMLId ? '' : $t.meta.input"
            :disabled="AMLId ? true : false"
          />

          <van-field
            v-model="item.SWIFT"
            :label="$t.antiMoneyLaundering.swift"
            :placeholder="AMLId ? '' : $t.meta.input"
            :disabled="AMLId ? true : false"
          />
        </div>
      </div>

      <div style="margin: 16px">
        <van-button
          round
          block
          type="info"
          native-type="button"
          @click="gotoQuery"
          v-if="AMLId"
          >{{ $t.antiMoneyLaundering.queryResult }}</van-button
        >
        <van-button round block type="info" native-type="submit" v-else>{{
          $t.antiMoneyLaundering.search
        }}</van-button>
      </div>
    </van-form>

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showKeywordDialog"
      @confirm="showKeywordDialog = false"
      @cancel="
        showKeywordDialog = false;
        initData();
      "
      :confirm-button-text="$t.meta.yes"
      :cancel-button-text="$t.meta.no"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        <div style="margin-bottom: 20px; text-align: left">
          {{ $t.antiMoneyLaundering.dialogQueryTitle }}
        </div>
        <div>
          <van-button size="small" type="info" @click="gotoQuery">{{
            $t.meta.viewClick
          }}</van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "antiMoneyLaunderingDetail",
  data() {
    return {
      AMLId: "",
      content: null,
      form: {
        id: "",
        SCAN_MODEL_LIST: [
          {
            NAME: "",
            ADDRESS: "",
            IDENTITYNUM: "",
            BIC: "",
            COUNTRY: "",
            NARRATIVE: "",
            SWIFT: "",
          },
        ],
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      showKeywordDialog: false,
    };
  },
  created() {
    const { AMLId } = this.$route.query;
    if (AMLId) {
      this.AMLId = AMLId;
      this.getAntiMoneyLaunderingScanListDetail();
    }
  },
  methods: {
    initData() {
      this.form.SCAN_MODEL_LIST = [
        {
          NAME: "",
          ADDRESS: "",
          IDENTITYNUM: "",
          BIC: "",
          COUNTRY: "",
          NARRATIVE: "",
          SWIFT: "",
        },
      ];
    },
    keywordSearch(event) {
      this.$commonMethod.showLoading();
      let param = {
        Keyword: event.target.value,
      };
      this.$api.marketRisk
        .getAntiMoneyLaunderingRecordsByKeyword(param)
        .then((res) => {
          if (res.data && res.data.AMLId) {
            this.form.id = res.data.AMLId;
            this.showKeywordDialog = true;
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    handleResult() {
      if (this.content) {
        this.gotoQuery(this.content);
      } else {
        this.gotoQuery();
      }
    },
    gotoQuery(content) {
      var query = [];
      if (content) {
        query = [
          {
            name: "Content",
            value: JSON.stringify(content),
          },
        ];
      }
      if (this.form.id) {
        query = [
          {
            name: "AMLId",
            value: this.form.id,
          },
        ];
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "antiMoneyLaunderingQuery",
        name: "antiMoneyLaunderingQuery",
        query: query,
      });
    },
    getAntiMoneyLaunderingScanListDetail() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          AMLId: this.AMLId,
        };
        this.$api.marketRisk
          .getAntiMoneyLaunderingScanListDetail(param)
          .then((res) => {
            this.form.id = res.data[0].AMLId;
            this.form.SCAN_MODEL_LIST = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    onSubmit() {
      if (this.content) {
        this.handleResult();
      } else {
        this.$commonMethod.showLoading();
        var param = this.form;
        this.$api.marketRisk
          .getAntiMoneyLaunderingListQuery(param)
          .then((res) => {
            this.content = res.data;
            this.handleResult();
            this.$commonMethod.hideLoading();
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.antiMoneyLaunderingDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .avatarImg {
    width: 50px;
    height: 50px;
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .tool-button {
      align-items: center;
    }
  }
}
</style>
